import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo 業務選擇 - 取得頁面資料
 */
const BusinessSelectionViewData = [
    'POST',
    RouteUrlList.API_BusinessSelectionViewData.path,
    {},
    200,
    {
        businessCategoryList: [
            {
                categoryID: 100,
                parentID: 10,
                categoryAlias: '開戶-證券-本國自然人',
                categoryName: '本國自然人',
                categoryLevel: 3,
                sortOrder: 1,
                isActive: true,
                isDeleted: false,
                createdTime: '2025-11-14T08:04:32.4533333',
                lastUpdate: '2025-11-14T08:04:32.4533333',
                description: '本國自然人證券開戶',
                totalCount: 0
            },
            {
                categoryID: 406,
                parentID: 43,
                categoryAlias: '定期審查-低中高風險-本國自然人',
                categoryName: '本國自然人',
                categoryLevel: 3,
                sortOrder: 1,
                isActive: true,
                isDeleted: false,
                createdTime: '2025-11-14T08:04:32.4533333',
                lastUpdate: '2025-11-14T08:04:32.4533333',
                description: '本國自然人風險等級審查',
                totalCount: 0
            }
        ],
        uploadItems: [
            {
                children: [
                    {
                        children: [],
                        itemID: 101,
                        parentID: 1,
                        parentItemName: null,
                        itemLevel: 2,
                        itemCode: null,
                        itemName: '(1)身分證正面',
                        isLeafNode: true,
                        sortOrder: 1,
                        isActive: true,
                        createdTime: '2025-11-14T10:13:00.8066667',
                        lastUpdate: '2025-11-14T10:13:00.8066667',
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: true,
                        ocrType: 'IdFront',
                        maxMultiUpload: 0,
                        totalCount: 0
                    },
                    {
                        children: [],
                        itemID: 102,
                        parentID: 1,
                        parentItemName: null,
                        itemLevel: 2,
                        itemCode: null,
                        itemName: '(2)身分證反面',
                        isLeafNode: true,
                        sortOrder: 2,
                        isActive: true,
                        createdTime: '2025-11-14T10:13:00.8066667',
                        lastUpdate: '2025-11-14T10:13:00.8066667',
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 0,
                        totalCount: 0
                    },
                    {
                        children: [],
                        itemID: 103,
                        parentID: 1,
                        parentItemName: null,
                        itemLevel: 2,
                        itemCode: null,
                        itemName: '(3)第二證件',
                        isLeafNode: true,
                        sortOrder: 3,
                        isActive: true,
                        createdTime: '2025-11-14T10:13:00.8066667',
                        lastUpdate: '2025-11-14T10:13:00.8066667',
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 0,
                        totalCount: 0
                    },
                    {
                        children: [],
                        itemID: 104,
                        parentID: 1,
                        parentItemName: null,
                        itemLevel: 2,
                        itemCode: null,
                        itemName: '(4)居留證正面',
                        isLeafNode: true,
                        sortOrder: 4,
                        isActive: true,
                        createdTime: '2025-11-14T10:13:00.8066667',
                        lastUpdate: '2025-11-14T10:13:00.8066667',
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 0,
                        totalCount: 0
                    },
                    {
                        children: [],
                        itemID: 105,
                        parentID: 1,
                        parentItemName: null,
                        itemLevel: 2,
                        itemCode: null,
                        itemName: '(5)居留證反面',
                        isLeafNode: true,
                        sortOrder: 5,
                        isActive: true,
                        createdTime: '2025-11-14T10:13:00.8066667',
                        lastUpdate: '2025-11-14T10:13:00.8066667',
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 0,
                        totalCount: 0
                    },
                    {
                        children: [],
                        itemID: 106,
                        parentID: 1,
                        parentItemName: null,
                        itemLevel: 2,
                        itemCode: null,
                        itemName: '(10)英文戶名證明文件',
                        isLeafNode: true,
                        sortOrder: 6,
                        isActive: true,
                        createdTime: '2025-11-14T10:13:00.8066667',
                        lastUpdate: '2025-11-14T10:13:00.8066667',
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 0
                    },
                    {
                        children: [],
                        itemID: 107,
                        parentID: 1,
                        parentItemName: null,
                        itemLevel: 2,
                        itemCode: null,
                        itemName: '(13)負責人第一證件',
                        isLeafNode: true,
                        sortOrder: 7,
                        isActive: true,
                        createdTime: '2025-11-14T10:13:00.8066667',
                        lastUpdate: '2025-11-14T10:13:00.8066667',
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 0
                    },
                    {
                        children: [],
                        itemID: 108,
                        parentID: 1,
                        parentItemName: null,
                        itemLevel: 2,
                        itemCode: null,
                        itemName: '(14)負責人第二證件',
                        isLeafNode: true,
                        sortOrder: 8,
                        isActive: true,
                        createdTime: '2025-11-14T10:13:00.8066667',
                        lastUpdate: '2025-11-14T10:13:00.8066667',
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 0
                    },
                    {
                        children: [],
                        itemID: 109,
                        parentID: 1,
                        parentItemName: null,
                        itemLevel: 2,
                        itemCode: null,
                        itemName: '(15)持股超過 25%自然人之第一證件',
                        isLeafNode: true,
                        sortOrder: 9,
                        isActive: true,
                        createdTime: '2025-11-14T10:13:00.8066667',
                        lastUpdate: '2025-11-14T10:13:00.8066667',
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 0
                    },
                    {
                        children: [],
                        itemID: 110,
                        parentID: 1,
                        parentItemName: null,
                        itemLevel: 2,
                        itemCode: null,
                        itemName: '(16)持股超過 25%自然人之第二證件',
                        isLeafNode: true,
                        sortOrder: 10,
                        isActive: true,
                        createdTime: '2025-11-14T10:13:00.8066667',
                        lastUpdate: '2025-11-14T10:13:00.8066667',
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 0
                    },
                    {
                        children: [],
                        itemID: 111,
                        parentID: 1,
                        parentItemName: null,
                        itemLevel: 2,
                        itemCode: null,
                        itemName: '(28)戶口名簿',
                        isLeafNode: true,
                        sortOrder: 11,
                        isActive: true,
                        createdTime: '2025-11-14T10:13:00.8066667',
                        lastUpdate: '2025-11-14T10:13:00.8066667',
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 0
                    },
                    {
                        children: [],
                        itemID: 112,
                        parentID: 1,
                        parentItemName: null,
                        itemLevel: 2,
                        itemCode: null,
                        itemName: '(29)戶籍謄本',
                        isLeafNode: true,
                        sortOrder: 12,
                        isActive: true,
                        createdTime: '2025-11-14T10:13:00.8066667',
                        lastUpdate: '2025-11-14T10:13:00.8066667',
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 0
                    }
                ],
                itemID: 1,
                parentID: null,
                parentItemName: null,
                itemLevel: 1,
                itemCode: null,
                itemName: '身分證明',
                isLeafNode: false,
                sortOrder: 1,
                isActive: true,
                createdTime: '2025-11-14T10:13:00.8066667',
                lastUpdate: '2025-11-14T10:13:00.8066667',
                description: null,
                maxFileSize: null,
                isAPIAvailable: true,
                isRequiredOcr: false,
                ocrType: null,
                maxMultiUpload: 0,
                totalCount: 0
            },
            {
                children: [
                    {
                        children: [],
                        itemID: 201,
                        parentID: 2,
                        parentItemName: null,
                        itemLevel: 2,
                        itemCode: null,
                        itemName: '(6)財力證明',
                        isLeafNode: true,
                        sortOrder: 1,
                        isActive: true,
                        createdTime: '2025-11-14T10:13:00.8066667',
                        lastUpdate: '2025-11-14T10:13:00.8066667',
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 0
                    },
                    {
                        children: [],
                        itemID: 202,
                        parentID: 2,
                        parentItemName: null,
                        itemLevel: 2,
                        itemCode: null,
                        itemName: '(6-1)庫存市值',
                        isLeafNode: true,
                        sortOrder: 2,
                        isActive: true,
                        createdTime: '2025-11-14T10:13:00.8066667',
                        lastUpdate: '2025-11-14T10:13:00.8066667',
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 0
                    },
                    {
                        children: [],
                        itemID: 203,
                        parentID: 2,
                        parentItemName: null,
                        itemLevel: 2,
                        itemCode: null,
                        itemName: '(6-2)銀行餘額(含存摺封面)',
                        isLeafNode: true,
                        sortOrder: 3,
                        isActive: true,
                        createdTime: '2025-11-14T10:13:00.8066667',
                        lastUpdate: '2025-11-14T10:13:00.8066667',
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 0
                    },
                    {
                        children: [],
                        itemID: 204,
                        parentID: 2,
                        parentItemName: null,
                        itemLevel: 2,
                        itemCode: null,
                        itemName: '(6-3)金融機構定期存單、',
                        isLeafNode: true,
                        sortOrder: 4,
                        isActive: true,
                        createdTime: '2025-11-14T10:13:00.8066667',
                        lastUpdate: '2025-11-14T10:13:00.8066667',
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 0
                    },
                    {
                        children: [],
                        itemID: 205,
                        parentID: 2,
                        parentItemName: null,
                        itemLevel: 2,
                        itemCode: null,
                        itemName: '(6-4)不動產證明',
                        isLeafNode: true,
                        sortOrder: 5,
                        isActive: true,
                        createdTime: '2025-11-14T10:13:00.8066667',
                        lastUpdate: '2025-11-14T10:13:00.8066667',
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 0
                    },
                    {
                        children: [],
                        itemID: 206,
                        parentID: 2,
                        parentItemName: null,
                        itemLevel: 2,
                        itemCode: null,
                        itemName: '(6-5)存款餘額證明',
                        isLeafNode: true,
                        sortOrder: 6,
                        isActive: true,
                        createdTime: '2025-11-14T10:13:00.8066667',
                        lastUpdate: '2025-11-14T10:13:00.8066667',
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 0
                    },
                    {
                        children: [],
                        itemID: 207,
                        parentID: 2,
                        parentItemName: null,
                        itemLevel: 2,
                        itemCode: null,
                        itemName: '(6-6)綜合存款對帳單',
                        isLeafNode: true,
                        sortOrder: 7,
                        isActive: true,
                        createdTime: '2025-11-14T10:13:00.8066667',
                        lastUpdate: '2025-11-14T10:13:00.8066667',
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 0
                    },
                    {
                        children: [],
                        itemID: 208,
                        parentID: 2,
                        parentItemName: null,
                        itemLevel: 2,
                        itemCode: null,
                        itemName: '(6-7)扣繳憑單',
                        isLeafNode: true,
                        sortOrder: 8,
                        isActive: true,
                        createdTime: '2025-11-14T10:13:00.8066667',
                        lastUpdate: '2025-11-14T10:13:00.8066667',
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 0
                    },
                    {
                        children: [],
                        itemID: 209,
                        parentID: 2,
                        parentItemName: null,
                        itemLevel: 2,
                        itemCode: null,
                        itemName: '(6-8)補摺證明',
                        isLeafNode: true,
                        sortOrder: 9,
                        isActive: true,
                        createdTime: '2025-11-14T10:13:00.8066667',
                        lastUpdate: '2025-11-14T10:13:00.8066667',
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 0
                    },
                    {
                        children: [],
                        itemID: 210,
                        parentID: 2,
                        parentItemName: null,
                        itemLevel: 2,
                        itemCode: null,
                        itemName: '(6-9)稅單',
                        isLeafNode: true,
                        sortOrder: 10,
                        isActive: true,
                        createdTime: '2025-11-14T10:13:00.8066667',
                        lastUpdate: '2025-11-14T10:13:00.8066667',
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 0
                    },
                    {
                        children: [],
                        itemID: 211,
                        parentID: 2,
                        parentItemName: null,
                        itemLevel: 2,
                        itemCode: null,
                        itemName: '(6-10)其他',
                        isLeafNode: true,
                        sortOrder: 11,
                        isActive: true,
                        createdTime: '2025-11-14T10:13:00.8066667',
                        lastUpdate: '2025-11-14T10:13:00.8066667',
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 0
                    }
                ],
                itemID: 2,
                parentID: null,
                parentItemName: null,
                itemLevel: 1,
                itemCode: null,
                itemName: '財力證明',
                isLeafNode: false,
                sortOrder: 2,
                isActive: true,
                createdTime: '2025-11-14T10:13:00.8066667',
                lastUpdate: '2025-11-14T10:13:00.8066667',
                description: null,
                maxFileSize: null,
                isAPIAvailable: true,
                isRequiredOcr: false,
                ocrType: null,
                maxMultiUpload: 0,
                totalCount: 0
            },
            {
                children: [
                    {
                        children: [],
                        itemID: 301,
                        parentID: 3,
                        parentItemName: null,
                        itemLevel: 2,
                        itemCode: null,
                        itemName: '(7)開戶 3 個月證明',
                        isLeafNode: true,
                        sortOrder: 1,
                        isActive: true,
                        createdTime: '2025-11-14T10:13:00.8066667',
                        lastUpdate: '2025-11-14T10:13:00.8066667',
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 0
                    },
                    {
                        children: [],
                        itemID: 302,
                        parentID: 3,
                        parentItemName: null,
                        itemLevel: 2,
                        itemCode: null,
                        itemName: '(8)交易紀錄',
                        isLeafNode: true,
                        sortOrder: 2,
                        isActive: true,
                        createdTime: '2025-11-14T10:13:00.8066667',
                        lastUpdate: '2025-11-14T10:13:00.8066667',
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 0
                    }
                ],
                itemID: 3,
                parentID: null,
                parentItemName: null,
                itemLevel: 1,
                itemCode: null,
                itemName: '交易紀錄',
                isLeafNode: false,
                sortOrder: 3,
                isActive: true,
                createdTime: '2025-11-14T10:13:00.8066667',
                lastUpdate: '2025-11-14T10:13:00.8066667',
                description: null,
                maxFileSize: null,
                isAPIAvailable: true,
                isRequiredOcr: false,
                ocrType: null,
                maxMultiUpload: 0,
                totalCount: 0
            },
            {
                children: [
                    {
                        children: [],
                        itemID: 401,
                        parentID: 4,
                        parentItemName: null,
                        itemLevel: 2,
                        itemCode: null,
                        itemName: '(9)出入金銀行帳戶',
                        isLeafNode: true,
                        sortOrder: 1,
                        isActive: true,
                        createdTime: '2025-11-14T10:13:00.8066667',
                        lastUpdate: '2025-11-14T10:13:00.8066667',
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 0
                    },
                    {
                        children: [],
                        itemID: 402,
                        parentID: 4,
                        parentItemName: null,
                        itemLevel: 2,
                        itemCode: null,
                        itemName: '(12)公司之股權證明文件',
                        isLeafNode: true,
                        sortOrder: 2,
                        isActive: true,
                        createdTime: '2025-11-14T10:13:00.8066667',
                        lastUpdate: '2025-11-14T10:13:00.8066667',
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 0
                    },
                    {
                        children: [],
                        itemID: 403,
                        parentID: 4,
                        parentItemName: null,
                        itemLevel: 2,
                        itemCode: null,
                        itemName: '(17)公司執照',
                        isLeafNode: true,
                        sortOrder: 3,
                        isActive: true,
                        createdTime: '2025-11-14T10:13:00.8066667',
                        lastUpdate: '2025-11-14T10:13:00.8066667',
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 0
                    },
                    {
                        children: [],
                        itemID: 404,
                        parentID: 4,
                        parentItemName: null,
                        itemLevel: 2,
                        itemCode: null,
                        itemName: '(18)六個月內簽發之職權證明書',
                        isLeafNode: true,
                        sortOrder: 4,
                        isActive: true,
                        createdTime: '2025-11-14T10:13:00.8066667',
                        lastUpdate: '2025-11-14T10:13:00.8066667',
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 0
                    },
                    {
                        children: [],
                        itemID: 405,
                        parentID: 4,
                        parentItemName: null,
                        itemLevel: 2,
                        itemCode: null,
                        itemName: '(19)存續證明',
                        isLeafNode: true,
                        sortOrder: 5,
                        isActive: true,
                        createdTime: '2025-11-14T10:13:00.8066667',
                        lastUpdate: '2025-11-14T10:13:00.8066667',
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 0
                    },
                    {
                        children: [],
                        itemID: 406,
                        parentID: 4,
                        parentItemName: null,
                        itemLevel: 2,
                        itemCode: null,
                        itemName: '(20)公司組織章程',
                        isLeafNode: true,
                        sortOrder: 6,
                        isActive: true,
                        createdTime: '2025-11-14T10:13:00.8066667',
                        lastUpdate: '2025-11-14T10:13:00.8066667',
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 0
                    },
                    {
                        children: [],
                        itemID: 407,
                        parentID: 4,
                        parentItemName: null,
                        itemLevel: 2,
                        itemCode: null,
                        itemName: '(21)董事名冊',
                        isLeafNode: true,
                        sortOrder: 7,
                        isActive: true,
                        createdTime: '2025-11-14T10:13:00.8066667',
                        lastUpdate: '2025-11-14T10:13:00.8066667',
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 0
                    },
                    {
                        children: [],
                        itemID: 408,
                        parentID: 4,
                        parentItemName: null,
                        itemLevel: 2,
                        itemCode: null,
                        itemName: '(22)股東名冊',
                        isLeafNode: true,
                        sortOrder: 8,
                        isActive: true,
                        createdTime: '2025-11-14T10:13:00.8066667',
                        lastUpdate: '2025-11-14T10:13:00.8066667',
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 0
                    },
                    {
                        children: [],
                        itemID: 409,
                        parentID: 4,
                        parentItemName: null,
                        itemLevel: 2,
                        itemCode: null,
                        itemName: '(23)公司註冊證書',
                        isLeafNode: true,
                        sortOrder: 9,
                        isActive: true,
                        createdTime: '2025-11-14T10:13:00.8066667',
                        lastUpdate: '2025-11-14T10:13:00.8066667',
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 0
                    },
                    {
                        children: [],
                        itemID: 410,
                        parentID: 4,
                        parentItemName: null,
                        itemLevel: 2,
                        itemCode: null,
                        itemName: '(24)商業登記',
                        isLeafNode: true,
                        sortOrder: 10,
                        isActive: true,
                        createdTime: '2025-11-14T10:13:00.8066667',
                        lastUpdate: '2025-11-14T10:13:00.8066667',
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 0
                    },
                    {
                        children: [],
                        itemID: 411,
                        parentID: 4,
                        parentItemName: null,
                        itemLevel: 2,
                        itemCode: null,
                        itemName: '(25)最新公司註冊處之週年申報表',
                        isLeafNode: true,
                        sortOrder: 11,
                        isActive: true,
                        createdTime: '2025-11-14T10:13:00.8066667',
                        lastUpdate: '2025-11-14T10:13:00.8066667',
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 0
                    },
                    {
                        children: [],
                        itemID: 412,
                        parentID: 4,
                        parentItemName: null,
                        itemLevel: 2,
                        itemCode: null,
                        itemName: '(26)更改公司秘書及董事通知書',
                        isLeafNode: true,
                        sortOrder: 12,
                        isActive: true,
                        createdTime: '2025-11-14T10:13:00.8066667',
                        lastUpdate: '2025-11-14T10:13:00.8066667',
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 0
                    },
                    {
                        children: [],
                        itemID: 413,
                        parentID: 4,
                        parentItemName: null,
                        itemLevel: 2,
                        itemCode: null,
                        itemName: '(27)股份分配申報表',
                        isLeafNode: true,
                        sortOrder: 13,
                        isActive: true,
                        createdTime: '2025-11-14T10:13:00.8066667',
                        lastUpdate: '2025-11-14T10:13:00.8066667',
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 0
                    },
                    {
                        children: [],
                        itemID: 414,
                        parentID: 4,
                        parentItemName: null,
                        itemLevel: 2,
                        itemCode: null,
                        itemName: '(30)證券交割帳戶約定申請暨委託書',
                        isLeafNode: true,
                        sortOrder: 14,
                        isActive: true,
                        createdTime: '2025-11-14T10:13:00.8066667',
                        lastUpdate: '2025-11-14T10:13:00.8066667',
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 0
                    },
                    {
                        children: [],
                        itemID: 415,
                        parentID: 4,
                        parentItemName: null,
                        itemLevel: 2,
                        itemCode: null,
                        itemName: '(31)受託買賣外國有價證券委託約定書',
                        isLeafNode: true,
                        sortOrder: 15,
                        isActive: true,
                        createdTime: '2025-11-14T10:13:00.8066667',
                        lastUpdate: '2025-11-14T10:13:00.8066667',
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 0
                    }
                ],
                itemID: 4,
                parentID: null,
                parentItemName: null,
                itemLevel: 1,
                itemCode: null,
                itemName: '文件證明',
                isLeafNode: false,
                sortOrder: 4,
                isActive: true,
                createdTime: '2025-11-14T10:13:00.8066667',
                lastUpdate: '2025-11-14T10:13:00.8066667',
                description: null,
                maxFileSize: null,
                isAPIAvailable: true,
                isRequiredOcr: false,
                ocrType: null,
                maxMultiUpload: 0,
                totalCount: 0
            },
            {
                children: [
                    {
                        children: [],
                        itemID: 501,
                        parentID: 5,
                        parentItemName: null,
                        itemLevel: 2,
                        itemCode: null,
                        itemName: '(32)其他 尚未分類',
                        isLeafNode: true,
                        sortOrder: 1,
                        isActive: true,
                        createdTime: '2025-11-14T10:13:00.8066667',
                        lastUpdate: '2025-11-14T10:13:00.8066667',
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 0
                    }
                ],
                itemID: 5,
                parentID: null,
                parentItemName: null,
                itemLevel: 1,
                itemCode: null,
                itemName: '其他',
                isLeafNode: false,
                sortOrder: 5,
                isActive: true,
                createdTime: '2025-11-14T10:13:00.8066667',
                lastUpdate: '2025-11-14T10:13:00.8066667',
                description: null,
                maxFileSize: null,
                isAPIAvailable: true,
                isRequiredOcr: false,
                ocrType: null,
                maxMultiUpload: 0,
                totalCount: 0
            }
        ],
        clientCaseInfo: [
            {
                caseData: {
                    masterCaseID: 'c119f27a-8f19-424e-8a08-d6ec450aa77e',
                    caseNumber: '02025111400003',
                    ermsCaseNo: null,
                    businessCategoryID: 406,
                    customerSalesRep: '',
                    branch: '8840',
                    ssn: 'A123456789',
                    account: '9801313',
                    mobilephone: '0912345678',
                    customerName: '測試小豬',
                    customerEmail: 'test@esunsec.com',
                    birthDay: null,
                    creatorBranch: '884M',
                    creatorEmployeeNo: 'admin',
                    processorEmployeeNo: 'admin',
                    expiryDate: '2025-11-25T17:11:51.7133333',
                    caseStatus: 2,
                    caseSource: 'WEB',
                    apiSystemCode: null,
                    notificationMethod: null,
                    sentDateTime: null,
                    isActive: 'True',
                    isDeleted: 'False',
                    createdTime: '2025-11-14T09:11:51.8666667',
                    lastUpdate: '2025-11-14T09:11:51.8666667',
                    completedTime: null,
                    notes: null,
                    totalCount: 0
                },
                caseUploadSelections: [
                    {
                        selectionID: 'f81f1f76-06c4-4c0a-82b9-261903533869',
                        caseID: 'c119f27a-8f19-424e-8a08-d6ec450aa77e',
                        itemID: 501,
                        isRequired: true,
                        createdTime: '2025-11-14T09:11:52.3433333',
                        lastUpdate: '2025-11-14T09:11:52.3433333',
                        itemName: '(32)其他 尚未分類',
                        itemLevel: 2,
                        parentID: 5,
                        isLeafNode: true,
                        sortOrder: 1,
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 10
                    },
                    {
                        selectionID: 'f6c0dcce-c53c-4711-8691-67728cee599a',
                        caseID: 'c119f27a-8f19-424e-8a08-d6ec450aa77e',
                        itemID: 407,
                        isRequired: true,
                        createdTime: '2025-11-14T09:11:52.3366667',
                        lastUpdate: '2025-11-14T09:11:52.3366667',
                        itemName: '(21)董事名冊',
                        itemLevel: 2,
                        parentID: 4,
                        isLeafNode: true,
                        sortOrder: 7,
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 10
                    },
                    {
                        selectionID: 'a16bf7a1-f146-4981-81c6-e196abe45b40',
                        caseID: 'c119f27a-8f19-424e-8a08-d6ec450aa77e',
                        itemID: 408,
                        isRequired: true,
                        createdTime: '2025-11-14T09:11:52.3333333',
                        lastUpdate: '2025-11-14T09:11:52.3333333',
                        itemName: '(22)股東名冊',
                        itemLevel: 2,
                        parentID: 4,
                        isLeafNode: true,
                        sortOrder: 8,
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 10
                    },
                    {
                        selectionID: '893ddd17-dd23-42c0-8785-31e1ecce1370',
                        caseID: 'c119f27a-8f19-424e-8a08-d6ec450aa77e',
                        itemID: 409,
                        isRequired: true,
                        createdTime: '2025-11-14T09:11:52.33',
                        lastUpdate: '2025-11-14T09:11:52.33',
                        itemName: '(23)公司註冊證書',
                        itemLevel: 2,
                        parentID: 4,
                        isLeafNode: true,
                        sortOrder: 9,
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 10
                    },
                    {
                        selectionID: '84d4002e-ce37-4c9a-9c09-24a7df7bcdf1',
                        caseID: 'c119f27a-8f19-424e-8a08-d6ec450aa77e',
                        itemID: 410,
                        isRequired: true,
                        createdTime: '2025-11-14T09:11:52.3266667',
                        lastUpdate: '2025-11-14T09:11:52.3266667',
                        itemName: '(24)商業登記',
                        itemLevel: 2,
                        parentID: 4,
                        isLeafNode: true,
                        sortOrder: 10,
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 10
                    },
                    {
                        selectionID: 'b25f841b-133e-4d0b-a538-c9f22894b291',
                        caseID: 'c119f27a-8f19-424e-8a08-d6ec450aa77e',
                        itemID: 411,
                        isRequired: true,
                        createdTime: '2025-11-14T09:11:52.28',
                        lastUpdate: '2025-11-14T09:11:52.28',
                        itemName: '(25)最新公司註冊處之週年申報表',
                        itemLevel: 2,
                        parentID: 4,
                        isLeafNode: true,
                        sortOrder: 11,
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 10
                    },
                    {
                        selectionID: 'aaa762c9-d755-48d3-9c26-0351fc696581',
                        caseID: 'c119f27a-8f19-424e-8a08-d6ec450aa77e',
                        itemID: 412,
                        isRequired: true,
                        createdTime: '2025-11-14T09:11:52.2633333',
                        lastUpdate: '2025-11-14T09:11:52.2633333',
                        itemName: '(26)更改公司秘書及董事通知書',
                        itemLevel: 2,
                        parentID: 4,
                        isLeafNode: true,
                        sortOrder: 12,
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 10
                    },
                    {
                        selectionID: '7606f2e0-f0b5-4af7-8f49-d9e871131aa7',
                        caseID: 'c119f27a-8f19-424e-8a08-d6ec450aa77e',
                        itemID: 413,
                        isRequired: true,
                        createdTime: '2025-11-14T09:11:52.35',
                        lastUpdate: '2025-11-14T09:11:52.35',
                        itemName: '(27)股份分配申報表',
                        itemLevel: 2,
                        parentID: 4,
                        isLeafNode: true,
                        sortOrder: 13,
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 10
                    },
                    {
                        selectionID: 'ba7a56c5-d5ef-4b78-ae56-1234d1e5ac49',
                        caseID: 'c119f27a-8f19-424e-8a08-d6ec450aa77e',
                        itemID: 414,
                        isRequired: true,
                        createdTime: '2025-11-14T09:11:52.3466667',
                        lastUpdate: '2025-11-14T09:11:52.3466667',
                        itemName: '(30)證券交割帳戶約定申請暨委託書',
                        itemLevel: 2,
                        parentID: 4,
                        isLeafNode: true,
                        sortOrder: 14,
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 10
                    },
                    {
                        selectionID: '16e96ce3-b6d9-4fdf-a431-c5fe28cc7cd2',
                        caseID: 'c119f27a-8f19-424e-8a08-d6ec450aa77e',
                        itemID: 415,
                        isRequired: true,
                        createdTime: '2025-11-14T09:11:52.34',
                        lastUpdate: '2025-11-14T09:11:52.34',
                        itemName: '(31)受託買賣外國有價證券委託約定書',
                        itemLevel: 2,
                        parentID: 4,
                        isLeafNode: true,
                        sortOrder: 15,
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 10
                    }
                ],
                uploadedDocuments: []
            },
            {
                caseData: {
                    masterCaseID: 'e8c80f96-91ad-4133-b137-3272d96c4dc0',
                    caseNumber: '02025111400001',
                    ermsCaseNo: null,
                    businessCategoryID: 100,
                    customerSalesRep: '',
                    branch: '8840',
                    ssn: 'A123456789',
                    account: '9801313',
                    mobilephone: '0912345678',
                    customerName: '測試小豬',
                    customerEmail: 'test@esunsec.com',
                    birthDay: null,
                    creatorBranch: '884M',
                    creatorEmployeeNo: 'admin',
                    processorEmployeeNo: 'admin',
                    expiryDate: '2025-11-25T16:52:37.5533333',
                    caseStatus: 2,
                    caseSource: 'WEB',
                    apiSystemCode: null,
                    notificationMethod: null,
                    sentDateTime: null,
                    isActive: 'True',
                    isDeleted: 'False',
                    createdTime: '2025-11-14T08:52:37.6066667',
                    lastUpdate: '2025-11-14T08:52:37.6066667',
                    completedTime: null,
                    notes: null,
                    totalCount: 0
                },
                caseUploadSelections: [
                    {
                        selectionID: '089a3270-cc39-4488-b85c-482d80e9dba8',
                        caseID: 'e8c80f96-91ad-4133-b137-3272d96c4dc0',
                        itemID: 101,
                        isRequired: true,
                        createdTime: '2025-11-14T08:52:37.8933333',
                        lastUpdate: '2025-11-14T08:52:37.8933333',
                        itemName: '(1)身分證正面',
                        itemLevel: 2,
                        parentID: 1,
                        isLeafNode: true,
                        sortOrder: 1,
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: true,
                        ocrType: 'IdFront',
                        maxMultiUpload: 0,
                        totalCount: 15
                    },
                    {
                        selectionID: '6e964ccb-8f3e-4637-b0e6-a5a0d1c391aa',
                        caseID: 'e8c80f96-91ad-4133-b137-3272d96c4dc0',
                        itemID: 201,
                        isRequired: true,
                        createdTime: '2025-11-14T08:52:37.9133333',
                        lastUpdate: '2025-11-14T08:52:37.9133333',
                        itemName: '(6)財力證明',
                        itemLevel: 2,
                        parentID: 2,
                        isLeafNode: true,
                        sortOrder: 1,
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 15
                    },
                    {
                        selectionID: 'df5a33d0-99dc-47d3-b770-dc0a3bce9a8a',
                        caseID: 'e8c80f96-91ad-4133-b137-3272d96c4dc0',
                        itemID: 302,
                        isRequired: true,
                        createdTime: '2025-11-14T08:52:37.9166667',
                        lastUpdate: '2025-11-14T08:52:37.9166667',
                        itemName: '(8)交易紀錄',
                        itemLevel: 2,
                        parentID: 3,
                        isLeafNode: true,
                        sortOrder: 2,
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 15
                    },
                    {
                        selectionID: '02f9aa41-a3ea-479e-90db-94808fe1051d',
                        caseID: 'e8c80f96-91ad-4133-b137-3272d96c4dc0',
                        itemID: 202,
                        isRequired: true,
                        createdTime: '2025-11-14T08:52:37.9133333',
                        lastUpdate: '2025-11-14T08:52:37.9133333',
                        itemName: '(6-1)庫存市值',
                        itemLevel: 2,
                        parentID: 2,
                        isLeafNode: true,
                        sortOrder: 2,
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 15
                    },
                    {
                        selectionID: '5b49035d-5862-4b11-873d-0ad640a8fa78',
                        caseID: 'e8c80f96-91ad-4133-b137-3272d96c4dc0',
                        itemID: 102,
                        isRequired: true,
                        createdTime: '2025-11-14T08:52:37.8966667',
                        lastUpdate: '2025-11-14T08:52:37.8966667',
                        itemName: '(2)身分證反面',
                        itemLevel: 2,
                        parentID: 1,
                        isLeafNode: true,
                        sortOrder: 2,
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 0,
                        totalCount: 15
                    },
                    {
                        selectionID: '2fe9fd8c-ecf0-4c1f-ae72-f49776dbf438',
                        caseID: 'e8c80f96-91ad-4133-b137-3272d96c4dc0',
                        itemID: 103,
                        isRequired: true,
                        createdTime: '2025-11-14T08:52:37.9',
                        lastUpdate: '2025-11-14T08:52:37.9',
                        itemName: '(3)第二證件',
                        itemLevel: 2,
                        parentID: 1,
                        isLeafNode: true,
                        sortOrder: 3,
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 0,
                        totalCount: 15
                    },
                    {
                        selectionID: '36bc5f9e-ae16-44ac-82b4-89fde1a5085f',
                        caseID: 'e8c80f96-91ad-4133-b137-3272d96c4dc0',
                        itemID: 203,
                        isRequired: true,
                        createdTime: '2025-11-14T08:52:37.9166667',
                        lastUpdate: '2025-11-14T08:52:37.9166667',
                        itemName: '(6-2)銀行餘額(含存摺封面)',
                        itemLevel: 2,
                        parentID: 2,
                        isLeafNode: true,
                        sortOrder: 3,
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 15
                    },
                    {
                        selectionID: 'b47c2987-8f8d-401f-9502-39125ac25c1a',
                        caseID: 'e8c80f96-91ad-4133-b137-3272d96c4dc0',
                        itemID: 104,
                        isRequired: true,
                        createdTime: '2025-11-14T08:52:37.9',
                        lastUpdate: '2025-11-14T08:52:37.9',
                        itemName: '(4)居留證正面',
                        itemLevel: 2,
                        parentID: 1,
                        isLeafNode: true,
                        sortOrder: 4,
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 0,
                        totalCount: 15
                    },
                    {
                        selectionID: '429be8a5-918f-41e4-992a-52b96ba7374b',
                        caseID: 'e8c80f96-91ad-4133-b137-3272d96c4dc0',
                        itemID: 204,
                        isRequired: true,
                        createdTime: '2025-11-14T08:52:37.9166667',
                        lastUpdate: '2025-11-14T08:52:37.9166667',
                        itemName: '(6-3)金融機構定期存單、',
                        itemLevel: 2,
                        parentID: 2,
                        isLeafNode: true,
                        sortOrder: 4,
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 15
                    },
                    {
                        selectionID: 'c76151e3-81e6-45e9-8fb8-61f0f81c324a',
                        caseID: 'e8c80f96-91ad-4133-b137-3272d96c4dc0',
                        itemID: 105,
                        isRequired: true,
                        createdTime: '2025-11-14T08:52:37.9033333',
                        lastUpdate: '2025-11-14T08:52:37.9033333',
                        itemName: '(5)居留證反面',
                        itemLevel: 2,
                        parentID: 1,
                        isLeafNode: true,
                        sortOrder: 5,
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 0,
                        totalCount: 15
                    },
                    {
                        selectionID: 'a51ecef1-2ae0-4c94-bb69-5a80e60422dc',
                        caseID: 'e8c80f96-91ad-4133-b137-3272d96c4dc0',
                        itemID: 106,
                        isRequired: true,
                        createdTime: '2025-11-14T08:52:37.9066667',
                        lastUpdate: '2025-11-14T08:52:37.9066667',
                        itemName: '(10)英文戶名證明文件',
                        itemLevel: 2,
                        parentID: 1,
                        isLeafNode: true,
                        sortOrder: 6,
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 15
                    },
                    {
                        selectionID: 'a2ba6b62-d2de-4fea-acbc-4e3c9749a293',
                        caseID: 'e8c80f96-91ad-4133-b137-3272d96c4dc0',
                        itemID: 107,
                        isRequired: true,
                        createdTime: '2025-11-14T08:52:37.9066667',
                        lastUpdate: '2025-11-14T08:52:37.9066667',
                        itemName: '(13)負責人第一證件',
                        itemLevel: 2,
                        parentID: 1,
                        isLeafNode: true,
                        sortOrder: 7,
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 15
                    },
                    {
                        selectionID: '18aa27c0-c2c2-45e4-ae5b-72750571624b',
                        caseID: 'e8c80f96-91ad-4133-b137-3272d96c4dc0',
                        itemID: 108,
                        isRequired: true,
                        createdTime: '2025-11-14T08:52:37.91',
                        lastUpdate: '2025-11-14T08:52:37.91',
                        itemName: '(14)負責人第二證件',
                        itemLevel: 2,
                        parentID: 1,
                        isLeafNode: true,
                        sortOrder: 8,
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 15
                    },
                    {
                        selectionID: 'd041e466-b678-4993-a74c-8f1fdbd7dd79',
                        caseID: 'e8c80f96-91ad-4133-b137-3272d96c4dc0',
                        itemID: 109,
                        isRequired: true,
                        createdTime: '2025-11-14T08:52:37.91',
                        lastUpdate: '2025-11-14T08:52:37.91',
                        itemName: '(15)持股超過 25%自然人之第一證件',
                        itemLevel: 2,
                        parentID: 1,
                        isLeafNode: true,
                        sortOrder: 9,
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 15
                    },
                    {
                        selectionID: '7915d7df-b606-4723-b612-5b46602f42c0',
                        caseID: 'e8c80f96-91ad-4133-b137-3272d96c4dc0',
                        itemID: 110,
                        isRequired: true,
                        createdTime: '2025-11-14T08:52:37.91',
                        lastUpdate: '2025-11-14T08:52:37.91',
                        itemName: '(16)持股超過 25%自然人之第二證件',
                        itemLevel: 2,
                        parentID: 1,
                        isLeafNode: true,
                        sortOrder: 10,
                        description: null,
                        maxFileSize: null,
                        isAPIAvailable: true,
                        isRequiredOcr: false,
                        ocrType: null,
                        maxMultiUpload: 5,
                        totalCount: 15
                    }
                ],
                uploadedDocuments: []
            }
        ],
        caseSupplementStatus: 1,
        status: true,
        code: -1,
        exception: '',
        message: ''
    }
];

export default BusinessSelectionViewData;
